<template>
  <div id="Home">
    <div>
      <h3>Vision of YGWG</h3>
      <hr>
      <div id="vision"> The vision of Young Geographer Working Group (YGWG) of Asian Geographical Association (AGA) is to bring together young geographers to foster a community for physical geography, human geography, GIScience and related research, with strong links to environment, health and sustainable development.
        <br><br>
      </div>
    </div>

    <div>
      <h3>Latest News</h3>
      <hr>
      <div v-for="(news, index) in latestNews" :key="news.path" class="news-item">
        <router-link :to="news.path">
          <strong class="home-h">{{ news.title }}<br></strong>
        </router-link>
        <small class="home-date">{{ news.date }}<br></small>
        <p>{{ news.summary }}</p>
        <p>
          <router-link :to="news.path">
            Read more…
          </router-link>
        </p>
        <hr v-if="index < latestNews.length - 1" class="news-divider">
      </div>
    </div>
    <el-backtop style="visibility-height:1400"></el-backtop>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      latestNews: [
        {
          path: '/Events/2026/1',
          title: 'The Fifth Asian Young Geographers Workshop Held at South China Normal University',
          date: 'June 5–7, 2026',
          summary: 'Under the theme “Innovating Asia, Reshaping the World,” the workshop welcomed more than 500 experts, scholars, and young geographers from over 20 countries and regions. Its program featured 22 parallel forums and 178 academic presentations.'
        },
        {
          path: '/Events/2024/1',
          title: 'The Fourth Asian Young Geographers Workshop Held in Yuxi',
          date: 'November 29–December 2, 2024',
          summary: 'A total of 378 experts and scholars from 58 institutions across 11 countries gathered in Yuxi, Yunnan Province, to exchange ideas under the theme “Asian Geography under Global Change.” This was the workshop’s first in-person edition.'
        },
        {
          path: '/Events/2023/1',
          title: 'The Third Asian Young Geographers Workshop Held Online',
          date: 'December 16–17, 2023',
          summary: 'The online workshop explored “Geography in a New Era” through eight keynote presentations and discussions across 20 topics. It recorded 637 attendances from 25 countries and regions, with 286 scholars giving oral presentations.'
        },
        {
          path: '/Events/2022/1',
          title: 'The Second Asian Young Geographers Workshop Held Online',
          date: 'December 17–18, 2022',
          summary: 'More than 400 scholars from 28 countries and regions joined the workshop on “Sustainable Development and Challenges Facing Asia.” Eight invited experts delivered keynote presentations, while 206 scholars presented their research.'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
#Home {
  font-size: 1.2rem;
  line-height: 2rem;
  width: 65%;
  margin: 0 auto;
  position: relative;
  word-spacing: 0.3rem;
  margin-top: 2.2rem;
  text-align: justify;
}

h3 {
  color: #117450;
  font-size: 1.3rem;
  font-weight: 1000;
}

hr {
  border: 0.1px solid;
  border-color: #eeeeee;
}

#vision {
  line-height: 2.1rem;
}

.home-h {
  font-size: larger;
  font-weight: bolder;
}

.home-date {
  font-weight: bold;
  color: grey;
}

.news-divider {
  border: 0;
  border-bottom: 3px double grey;
}

a {
  text-decoration: none;
  font-size: 1.2rem;
  color: #117450;
}
</style>
